import defaultMessages from './en';

const asyncLanguages = {
	cs: (): Promise<typeof import('./cs')> =>
		import(
			/* webpackChunkName: "@atlassian/conversation-assistant-chat-prompt-input/i18n/cs" */ './cs'
		),
	da: (): Promise<typeof import('./da')> =>
		import(
			/* webpackChunkName: "@atlassian/conversation-assistant-chat-prompt-input/i18n/da" */ './da'
		),
	de: (): Promise<typeof import('./de')> =>
		import(
			/* webpackChunkName: "@atlassian/conversation-assistant-chat-prompt-input/i18n/de" */ './de'
		),
	'en-GB': (): Promise<typeof import('./en_GB')> =>
		import(
			/* webpackChunkName: "@atlassian/conversation-assistant-chat-prompt-input/i18n/en_GB" */ './en_GB'
		),
	'en-ZZ': (): Promise<typeof import('./en_ZZ')> =>
		import(
			/* webpackChunkName: "@atlassian/conversation-assistant-chat-prompt-input/i18n/en_ZZ" */ './en_ZZ'
		),
	en: (): Promise<typeof import('./en')> =>
		import(
			/* webpackChunkName: "@atlassian/conversation-assistant-chat-prompt-input/i18n/en" */ './en'
		),
	es: (): Promise<typeof import('./es')> =>
		import(
			/* webpackChunkName: "@atlassian/conversation-assistant-chat-prompt-input/i18n/es" */ './es'
		),
	fi: (): Promise<typeof import('./fi')> =>
		import(
			/* webpackChunkName: "@atlassian/conversation-assistant-chat-prompt-input/i18n/fi" */ './fi'
		),
	fr: (): Promise<typeof import('./fr')> =>
		import(
			/* webpackChunkName: "@atlassian/conversation-assistant-chat-prompt-input/i18n/fr" */ './fr'
		),
	hr: (): Promise<typeof import('./hr')> =>
		import(
			/* webpackChunkName: "@atlassian/conversation-assistant-chat-prompt-input/i18n/hr" */ './hr'
		),
	hu: (): Promise<typeof import('./hu')> =>
		import(
			/* webpackChunkName: "@atlassian/conversation-assistant-chat-prompt-input/i18n/hu" */ './hu'
		),
	it: (): Promise<typeof import('./it')> =>
		import(
			/* webpackChunkName: "@atlassian/conversation-assistant-chat-prompt-input/i18n/it" */ './it'
		),
	ja: (): Promise<typeof import('./ja')> =>
		import(
			/* webpackChunkName: "@atlassian/conversation-assistant-chat-prompt-input/i18n/ja" */ './ja'
		),
	ko: (): Promise<typeof import('./ko')> =>
		import(
			/* webpackChunkName: "@atlassian/conversation-assistant-chat-prompt-input/i18n/ko" */ './ko'
		),
	nb: (): Promise<typeof import('./nb')> =>
		import(
			/* webpackChunkName: "@atlassian/conversation-assistant-chat-prompt-input/i18n/nb" */ './nb'
		),
	nl: (): Promise<typeof import('./nl')> =>
		import(
			/* webpackChunkName: "@atlassian/conversation-assistant-chat-prompt-input/i18n/nl" */ './nl'
		),
	pl: (): Promise<typeof import('./pl')> =>
		import(
			/* webpackChunkName: "@atlassian/conversation-assistant-chat-prompt-input/i18n/pl" */ './pl'
		),
	'pt-BR': (): Promise<typeof import('./pt_BR')> =>
		import(
			/* webpackChunkName: "@atlassian/conversation-assistant-chat-prompt-input/i18n/pt_BR" */ './pt_BR'
		),
	ru: (): Promise<typeof import('./ru')> =>
		import(
			/* webpackChunkName: "@atlassian/conversation-assistant-chat-prompt-input/i18n/ru" */ './ru'
		),
	sl: (): Promise<typeof import('./sl')> =>
		import(
			/* webpackChunkName: "@atlassian/conversation-assistant-chat-prompt-input/i18n/sl" */ './sl'
		),
	'sr-RS': (): Promise<typeof import('./sr_RS')> =>
		import(
			/* webpackChunkName: "@atlassian/conversation-assistant-chat-prompt-input/i18n/sr_RS" */ './sr_RS'
		),
	'sr-YR': (): Promise<typeof import('./sr_YR')> =>
		import(
			/* webpackChunkName: "@atlassian/conversation-assistant-chat-prompt-input/i18n/sr_YR" */ './sr_YR'
		),
	sv: (): Promise<typeof import('./sv')> =>
		import(
			/* webpackChunkName: "@atlassian/conversation-assistant-chat-prompt-input/i18n/sv" */ './sv'
		),
	th: (): Promise<typeof import('./th')> =>
		import(
			/* webpackChunkName: "@atlassian/conversation-assistant-chat-prompt-input/i18n/th" */ './th'
		),
	tr: (): Promise<typeof import('./tr')> =>
		import(
			/* webpackChunkName: "@atlassian/conversation-assistant-chat-prompt-input/i18n/tr" */ './tr'
		),
	uk: (): Promise<typeof import('./uk')> =>
		import(
			/* webpackChunkName: "@atlassian/conversation-assistant-chat-prompt-input/i18n/uk" */ './uk'
		),
	vi: (): Promise<typeof import('./vi')> =>
		import(
			/* webpackChunkName: "@atlassian/conversation-assistant-chat-prompt-input/i18n/vi" */ './vi'
		),
	'zh-TW': (): Promise<typeof import('./zh_TW')> =>
		import(
			/* webpackChunkName: "@atlassian/conversation-assistant-chat-prompt-input/i18n/zh_TW" */ './zh_TW'
		),
	zh: (): Promise<typeof import('./zh')> =>
		import(
			/* webpackChunkName: "@atlassian/conversation-assistant-chat-prompt-input/i18n/zh" */ './zh'
		),
} as const;

export const conversationAssistantChatPromptInputI18n: {
	defaultMessages: typeof defaultMessages;
	asyncLanguages: typeof asyncLanguages;
} = {
	defaultMessages: defaultMessages,
	asyncLanguages: asyncLanguages,
};
